import { IOrganizationUnit } from "@src/app/interfaces/api/organization-units.interface";

export class FilterDuplicateOrganization {
  public filter(units: IOrganizationUnit[]): IOrganizationUnit[] {
    const nestedIds = new Set<number>();
    const idToUnits = new Map<number, IOrganizationUnit[]>();

    for (const unit of units) {
      if (!idToUnits.has(unit.Id)) {
        idToUnits.set(unit.Id, []);
      }
      idToUnits.get(unit.Id)!.push(unit);
    }

    for (const unit of units) {
      this.collectNestedIds(unit.SubUnits, nestedIds);
    }

    const result: IOrganizationUnit[] = [];

    for (const [id, duplicates] of idToUnits.entries()) {
      if (nestedIds.has(id)) {
        continue;
      }

      const withChildren = duplicates.find(u => u.SubUnits && u.SubUnits.length > 0);
      if (withChildren) {
        result.push(withChildren);
      }
      else {
        result.push(duplicates[0]);
      }
    }
    return result;
  }

  private collectNestedIds(units: IOrganizationUnit[], idSet: Set<number>): void {
    for (const unit of units) {
      if (!idSet.has(unit.Id)) {
        idSet.add(unit.Id);
        if (unit.SubUnits?.length) {
          this.collectNestedIds(unit.SubUnits, idSet);
        }
      }
    }
  }
}
